import ItemCommonFields from '@/components/common/ItemCommonFields.vue';
import RemoteMonitoringItemCommonFields from '@/components/RemoteMonitoringItemCommonFields.vue';

export function getItemCommonFields() {
  return [
    {
      component: ItemCommonFields,
      props: (item: any) => ({ item })
    }
  ];
}

export function getRemoteMonitoringItemCommonFields() {
  return [
    {
      component: RemoteMonitoringItemCommonFields,
      props: (item: any) => ({ item })
    }
  ];
}
